// This file was automatically generated from render.formulary.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.formulary');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.limitations = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="formularyLimitationsHeader">Limitations</div><div class="formularyLimitationsContent">');
  if (opt_data.limitations.text_message) {
    output.append('<div class="formularyLimitationsDetails">');
    var messageList27917 = opt_data.limitations.text_message;
    var messageListLen27917 = messageList27917.length;
    for (var messageIndex27917 = 0; messageIndex27917 < messageListLen27917; messageIndex27917++) {
      var messageData27917 = messageList27917[messageIndex27917];
      output.append((messageData27917.short_message) ? '<div class="frame">Summary:</div><div>' + soy.$$escapeHtml(messageData27917.short_message) + '</div>' : '', (messageData27917.long_message) ? '<div class="frame">Detail:</div><div>' + soy.$$escapeHtml(messageData27917.long_message) + '</div>' : '');
    }
    output.append('</div>');
  }
  output.append((opt_data.limitations.coverage_exclusion) ? '<div class="frame">Coverage Exclusion:</div><div>' + soy.$$escapeHtml(opt_data.limitations.coverage_exclusion) + '</div>' : '', (opt_data.limitations.age_limit) ? '<div class="frame">Age Limits:</div><div>' + soy.$$escapeHtml(opt_data.limitations.age_limit) + '</div>' : '', (opt_data.limitations.gender_limit) ? '<div class="frame">Gender Limits:</div><div>' + soy.$$escapeHtml(opt_data.limitations.gender_limit) + '</div>' : '', (opt_data.limitations.qty_limit) ? '<div class="frame">Qty Limit:</div><div>' + soy.$$escapeHtml(opt_data.limitations.qty_limit) + '</div>' : '', (opt_data.limitations.med_necessity != null) ? '<div class="frame">Med Necessity:</div><div>' + soy.$$escapeHtml(opt_data.limitations.med_necessity) + '</div>' : '', (opt_data.limitations.prior_auth) ? '<div class="frame">Prior Auth:</div><div>' + soy.$$escapeHtml(opt_data.limitations.prior_auth) + '</div>' : '', (opt_data.limitations.step_therapy != null) ? '<div class="frame">Step Therapy:</div><div>' + soy.$$escapeHtml(opt_data.limitations.step_therapy) + '</div>' : '');
  if (opt_data.limitations.step_medication) {
    output.append('<div class="frame">Step Therapy:</div>');
    var medicationList27968 = opt_data.limitations.step_medication;
    var medicationListLen27968 = medicationList27968.length;
    for (var medicationIndex27968 = 0; medicationIndex27968 < medicationListLen27968; medicationIndex27968++) {
      var medicationData27968 = medicationList27968[medicationIndex27968];
      output.append('<div class="elt">', soy.$$escapeHtml(medicationData27968), '</div>');
    }
  }
  if (opt_data.limitations.resource_links_drug_specific) {
    output.append('<div><span class="frame elt">Resource Links Drug-Specific:</span>');
    var linkList27976 = opt_data.limitations.resource_links_drug_specific;
    var linkListLen27976 = linkList27976.length;
    for (var linkIndex27976 = 0; linkIndex27976 < linkListLen27976; linkIndex27976++) {
      var linkData27976 = linkList27976[linkIndex27976];
      output.append('<span class="elt"><a href="', soy.$$escapeHtml(linkData27976.link_url), '">', soy.$$escapeHtml(linkData27976.link_type), '</a></span>');
    }
    output.append('</div>');
  }
  if (opt_data.limitations.resource_links_summary) {
    output.append('<div><span class="frame elt">Resource Links Summary:</span>');
    var linkList27987 = opt_data.limitations.resource_links_summary;
    var linkListLen27987 = linkList27987.length;
    for (var linkIndex27987 = 0; linkIndex27987 < linkListLen27987; linkIndex27987++) {
      var linkData27987 = linkList27987[linkIndex27987];
      output.append('<span class="elt"><a href="', soy.$$escapeHtml(linkData27987.link_url), '">', soy.$$escapeHtml(linkData27987.link_type), '</a></span>');
    }
    output.append('</div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.copay = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8BulletText">', (opt_data.copay.pharmacy_type) ? soy.$$escapeHtml(opt_data.copay.pharmacy_type) + ':' : '', '<div class="formularyCopayDetails"><span class="frame elt">Co-pay:</span>', (opt_data.copay.copay_tier) ? '<span class="elt">' + soy.$$escapeHtml(opt_data.copay.copay_tier) + 'T</span>' : '', (opt_data.copay.maximum_copay_tier) ? '<span class="elt">(max: ' + soy.$$escapeHtml(opt_data.copay.maximum_copay_tier) + 'T)</span>' : '', (opt_data.copay.flat_copay_amt) ? '<span class="elt">| ' + soy.$$escapeHtml(opt_data.copay.flat_copay_amt) + '</span>' : '', (opt_data.copay.percent_copay_rate) ? '<span class="elt">| ' + soy.$$escapeHtml(opt_data.copay.percent_copay_rate) + '</span>' : '', (opt_data.copay.days_supply_per_copay) ? '<span class="elt">, ' + soy.$$escapeHtml(opt_data.copay.days_supply_per_copay) + ' days supply per co-pay</span>' : '', '</div><div class="formularyCopayDetails">', (opt_data.copay.first_copay_term) ? '<div class=""><span class="frame elt">First Co-pay Term:</span>' + soy.$$escapeHtml(opt_data.copay.first_copay_term) + '</div>' : '', (opt_data.copay.minimum_copay) ? '<div class=""><span class="frame elt">Minimum Co-pay:</span>' + soy.$$escapeHtml(opt_data.copay.minimum_copay) + '</div>' : '', (opt_data.copay.maximum_copay) ? '<div class=""><span class="frame elt">Maximum Co-pay:</span>' + soy.$$escapeHtml(opt_data.copay.maximum_copay) + '</div>' : '', (opt_data.copay.oop_range_start) ? '<div class=""><span class="frame elt">OOP start:</span>' + soy.$$escapeHtml(opt_data.copay.oop_range_start) + '</div>' : '', (opt_data.copay.oop_range_end) ? '<div class=""><span class="frame elt">OOP end:</span>' + soy.$$escapeHtml(opt_data.copay.oop_range_end) + '</div>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.altMedication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="itemBulletNoAction">', (opt_data.medication) ? '<div class="formularyAltMedItem"><a class="formulary-alt-trigger" _item_id="' + soy.$$escapeHtml(opt_data.medication_id) + '">' + soy.$$escapeHtml(opt_data.medication) + '</a></div>' : '', (opt_data.is_on_formulary) ? '<div class="formularyAltMedStatusCovered">' + soy.$$escapeHtml(opt_data.formulary_status) + '</div>' : '<div class="formularyAltMedStatusNotCovered">' + soy.$$escapeHtml(opt_data.formulary_status) + '</div>', (opt_data.abbre_copay) ? '<div class="formularyBenefitsDetailContainer">' + soy.$$escapeHtml(opt_data.abbre_copay) + '</div>' : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.medication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection">', (opt_data.is_on_formulary) ? '<span class="formularyStatusCovered">' + soy.$$escapeHtml(opt_data.formulary_status) + '</span>' : '<span class="formularyStatusNotCovered">' + soy.$$escapeHtml(opt_data.formulary_status) + '</span>', (opt_data.packaged_medication_id) ? '<span class="packaged-medication-id" style="display:none">' + soy.$$escapeHtml(opt_data.packaged_medication_id) + '</span>' : '', (opt_data.medication) ? '<p class="padv5 el8Bold el8AppColor">' + soy.$$escapeHtml(opt_data.medication) + '</p>' : '', '</div><p class="el8Spacer">', (opt_data.med_type) ? soy.$$escapeHtml(opt_data.med_type) : '', ' ', (opt_data.med_brand_type) ? soy.$$escapeHtml(opt_data.med_brand_type) : '', '</p>');
  if (opt_data.copay) {
    output.append('<ul>');
    if (opt_data.copay.drug_specific) {
      var cList28114 = opt_data.copay.drug_specific;
      var cListLen28114 = cList28114.length;
      for (var cIndex28114 = 0; cIndex28114 < cListLen28114; cIndex28114++) {
        var cData28114 = cList28114[cIndex28114];
        el8.template.render.formulary.copay({copay: cData28114}, output);
      }
    }
    if (opt_data.copay.summary_level) {
      var cList28120 = opt_data.copay.summary_level;
      var cListLen28120 = cList28120.length;
      for (var cIndex28120 = 0; cIndex28120 < cListLen28120; cIndex28120++) {
        var cData28120 = cList28120[cIndex28120];
        el8.template.render.formulary.copay({copay: cData28120}, output);
      }
    }
    output.append('</ul>');
  }
  if (opt_data.limitations) {
    if (opt_data.limitations.has_coverage_detail) {
      output.append('<div class="formularyCoverageDetailContainer"><div class="formularyCoverageDetailButtonContainer"><a class="coverage-detail-trigger generalButton">view coverage detail</a></div><div class="coverage-detail formularyCoverageDetail" style="display:none">');
      el8.template.render.formulary.limitations({limitations: opt_data.limitations}, output);
      output.append('</div></div>');
    }
  }
  if (opt_data.coverages) {
    output.append('<ol>');
    var coverageList28136 = opt_data.coverages;
    var coverageListLen28136 = coverageList28136.length;
    for (var coverageIndex28136 = 0; coverageIndex28136 < coverageListLen28136; coverageIndex28136++) {
      var coverageData28136 = coverageList28136[coverageIndex28136];
      output.append('<li class="el8StandardFontSize el8InlineItem">', (coverageData28136.status == 'Active Coverage') ? '<span class="elt">' + soy.$$escapeHtml(coverageData28136.service_type) + ':</span><span class="formularyBenefitsStatusCovered">' + soy.$$escapeHtml(coverageData28136.status) + '</span>' : '<span class="formularyBenefitsDetailNotCovered elt">' + soy.$$escapeHtml(coverageData28136.service_type) + ':</span><span class="formularyBenefitsStatusNotCovered">' + soy.$$escapeHtml(coverageData28136.status) + '</span>', '</li>');
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.eligibilityDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="formulary-medication-wrapper">');
  el8.template.render.formulary.medication({medication: opt_data.medication, packaged_medication_id: opt_data.formulary.packaged_medication_id, formulary_status: opt_data.formulary.formulary_status_display, is_on_formulary: opt_data.formulary.is_on_formulary, med_type: opt_data.formulary.med_type, med_brand_type: opt_data.formulary.med_brand_type, limitations: opt_data.coverage_limitation, coverages: (opt_data.eligibility) ? opt_data.eligibility.coverages : null, copay: (opt_data.eligibility) ? opt_data.eligibility.copay : null}, output);
  output.append('</div>');
  if (opt_data.alternatives) {
    if (opt_data.alternatives.no_alternatives) {
      output.append('<p class="el8FeedEmpty">No Alternatives</p>');
    } else {
      output.append('<div class="formulary-alternatives formularyAlternativesContainer">');
      if (opt_data.alternatives.surescripts_alternatives) {
        output.append('<div class="formularyAlternativesHeader">Payer-specified Alternatives</div><ul>');
        var altList28191 = opt_data.alternatives.surescripts_alternatives;
        var altListLen28191 = altList28191.length;
        for (var altIndex28191 = 0; altIndex28191 < altListLen28191; altIndex28191++) {
          var altData28191 = altList28191[altIndex28191];
          el8.template.render.formulary.altMedication({medication: altData28191.medication, medication_id: altData28191.medication_id, is_on_formulary: altData28191.formulary_result.is_on_formulary, formulary_status: altData28191.formulary_result.formulary_status_display, abbre_copay: altData28191.abbre_copay}, output);
        }
        output.append('</ul>');
      }
      if (opt_data.alternatives.therapeutic_alternatives) {
        output.append('<div class="formularyAlternativesHeader">Therapeutic Alternatives</div><ul>');
        var altList28203 = opt_data.alternatives.therapeutic_alternatives;
        var altListLen28203 = altList28203.length;
        for (var altIndex28203 = 0; altIndex28203 < altListLen28203; altIndex28203++) {
          var altData28203 = altList28203[altIndex28203];
          el8.template.render.formulary.altMedication({medication: altData28203.medication, medication_id: altData28203.medication_id, is_on_formulary: altData28203.formulary_result.is_on_formulary, formulary_status: altData28203.formulary_result.formulary_status_display, abbre_copay: altData28203.abbre_copay}, output);
        }
        output.append('</ul>');
      }
      if (opt_data.alternatives.drug_level_alternatives) {
        output.append('<div class="formularyAlternativesHeader">Other Alternatives</div><ul>');
        var altList28215 = opt_data.alternatives.drug_level_alternatives;
        var altListLen28215 = altList28215.length;
        for (var altIndex28215 = 0; altIndex28215 < altListLen28215; altIndex28215++) {
          var altData28215 = altList28215[altIndex28215];
          el8.template.render.formulary.altMedication({medication: altData28215.medication, medication_id: altData28215.medication_id, is_on_formulary: altData28215.formulary_result.is_on_formulary, formulary_status: altData28215.formulary_result.formulary_status_display, abbre_copay: altData28215.abbre_copay}, output);
        }
        output.append('</ul>');
      }
      output.append('</div>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.rxFormEligibility = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.has_valid_eligibilities) {
    if (opt_data.eligibilities.length > 1) {
      output.append('<div class="systemNoteContainer">Select plan from the dropdown to view coverage.</div><select class="w100" name="eligibilities">');
      var itemList28231 = opt_data.eligibilities;
      var itemListLen28231 = itemList28231.length;
      for (var itemIndex28231 = 0; itemIndex28231 < itemListLen28231; itemIndex28231++) {
        var itemData28231 = itemList28231[itemIndex28231];
        output.append((itemData28231.eligibility) ? '<option value="' + soy.$$escapeHtml(itemData28231.eligibility.id) + '">' + soy.$$escapeHtml(itemData28231.eligibility.pbm) + ((itemData28231.eligibility.plan_name) ? ' - ' + soy.$$escapeHtml(itemData28231.eligibility.plan_name) : '') + '</option>' : '');
      }
      output.append('</select>');
    } else if (opt_data.eligibilities.length == 1) {
      output.append((opt_data.eligibilities[0].eligibility) ? '<span class="eligibility-id hidden">' + soy.$$escapeHtml(opt_data.eligibilities[0].eligibility.id) + '</span><p class="padv5 el8Bold">Plan: ' + soy.$$escapeHtml(opt_data.eligibilities[0].eligibility.pbm) + ((opt_data.eligibilities[0].eligibility.plan_name) ? ' - ' + soy.$$escapeHtml(opt_data.eligibilities[0].eligibility.plan_name) : '') + '</p>' : '');
    }
    var itemList28257 = opt_data.eligibilities;
    var itemListLen28257 = itemList28257.length;
    if (itemListLen28257 > 0) {
      for (var itemIndex28257 = 0; itemIndex28257 < itemListLen28257; itemIndex28257++) {
        var itemData28257 = itemList28257[itemIndex28257];
        output.append('<div', (itemData28257.eligibility) ? ' id="meds-form-eligibility-' + soy.$$escapeHtml(itemData28257.eligibility.id) + '"' : '', ' class="formulary-eligibility" ', (! (itemIndex28257 == 0)) ? 'style="display:none"' : '', '>');
        el8.template.render.formulary.eligibilityDetails(itemData28257, output);
        output.append('</div>');
      }
    } else {
      output.append('<div class="formulary-eligibility"><p class="el8FeedEmpty">Formulary status unknown.</p></div>');
    }
  } else {
    el8.template.render.formulary.rxFormInitial({hasEligibility: false}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.rxFormInitial = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (el8Globals.PASSPORT_EMR || el8Globals.TEST_ACCOUNT) {
    el8.template.render.formulary.eRxAd(null, output);
  } else {
    output.append((opt_data.hasEligibility) ? '<p class="el8FeedEmpty">No formulary information</p>' : '<div class="formularyRecheck"><p class="el8LargeFontSize">Formulary information is not available, since we were unable to determine patient\'s medication insurance eligibility information.</p><div class="spacer"></div><div class="el8DialogButtonContainer"><button tabindex="-1" type="button" class="el8button eligibilities_trigger">Re-Check Medication Eligibility</button></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.formulary.eRxAd = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h2>Subscribe to Elation Health to:</h2><ul class="mt10"><li class="el8BulletText">Electronically prescribe to any pharmacy in the US.</li><li class="el8BulletText">Receive the meds your patient has picked up from the pharmacy, including meds prescribed by another doctor.</li><li class="el8BulletText">Get patient-specific co-pay and formulary status information.</li></ul><button class="mt10 erx-activate-trigger">Subscribe</button>');
  if (!opt_sb) return output.toString();
};
